import React from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import { PersonalForm } from "./personal-form/PersonalForm";
import { useNewReportState } from "presentation/new-report/NewReportContext";
import { GeneralSchema } from "./general-data-schema";

export const GeneralData = () => {
  const {
    generalDataRef,
    dataState: initialValues,
    userInfo,
  } = useNewReportState();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={GeneralSchema(userInfo, initialValues.managers)}
      onSubmit={() => {
      }}>
      {
        (formik) => {
          const {
            values,
            handleSubmit,
            setFieldValue,
            validateForm,
            setFieldTouched,
            isValid,
            errors,
            resetForm
          } = formik;

          generalDataRef.current = {
            validateForm,
            handleSubmit,
            isValid,
            values,
            errors,
            setFieldValue,
            setFieldTouched,
            resetForm,
          };

          return (
            <div className="p-sm overflow-x-hidden-sm">
              <PersonalForm
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                values={values} />
            </div>
          )
        }
      }
    </Formik>
  );
};

GeneralData.propTypes = {
  userInfo: PropTypes.any,
  initialValues: PropTypes.object
};

export default GeneralData;
